import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const style = require('./InvoicesPage.less');

export default class InvoicesPage extends React.Component<any, null> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_INVOICES} isPage>
				<div>
					<Route
						path="/buyer/invoices"
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: '/buyer/invoices/overview',
								}}
							/>
						)}
					/>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</div>
			</AccessPermissionChecker>
		);
	}
}
